import { injectCss } from "../../../../../../node_modules/@pebblepad/pebblepack/runtime/InjectCss.runtime.js";
injectCss(`.cui-boundary-bridge__container{display:unset}`);